"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchNode = void 0;
const Node_1 = require("./Node");
/**
 * Node that allows multiple types
 */
const SwitchNode = (cases) => {
    return {
        ...Node_1.Base,
        type(path) {
            return this.activeCase(path, true)
                .node.type(path);
        },
        category(path) {
            return this.activeCase(path, true)
                .node.category(path);
        },
        default: () => cases[0].node.default(),
        navigate(path, index) {
            var _a;
            const nextIndex = index + 1;
            return (_a = this.activeCase(path.slice(0, nextIndex))) === null || _a === void 0 ? void 0 : _a.node.navigate(path, index);
        },
        pathPush(path, key) {
            var _a, _b;
            return (_b = (_a = this.activeCase(path)) === null || _a === void 0 ? void 0 : _a.node.pathPush(path, key)) !== null && _b !== void 0 ? _b : path;
        },
        suggest(path, value) {
            var _a, _b;
            return (_b = (_a = this.activeCase(path)) === null || _a === void 0 ? void 0 : _a.node.suggest(path, value)) !== null && _b !== void 0 ? _b : cases
                .filter(c => c.match(path))
                .map(c => c.node.suggest(path, value))
                .reduce((p, c) => p.concat(c));
        },
        validate(path, value, errors, options) {
            let c = this.activeCase(path);
            if (c === undefined) {
                return value;
            }
            return c.node.validate(path, value, errors, options);
        },
        validationOption(path) {
            var _a;
            return (_a = this.activeCase(path)) === null || _a === void 0 ? void 0 : _a.node.validationOption(path);
        },
        activeCase(path, fallback) {
            const sorter = (a, b) => { var _a, _b; return ((_a = b.priority) !== null && _a !== void 0 ? _a : 0) - ((_b = a.priority) !== null && _b !== void 0 ? _b : 0); };
            const matchedCases = cases.filter(c => c.match(path)).sort(sorter);
            if (fallback && matchedCases.length === 0) {
                return cases.sort(sorter)[0];
            }
            return (matchedCases.length > 0 ? matchedCases[0] : undefined);
        },
        hook(hook, path, ...args) {
            return this.activeCase(path, true)
                .node.hook(hook, path, ...args);
        },
    };
};
exports.SwitchNode = SwitchNode;
